/**
 * Chrome translation and some extensions rewrite text nodes after React creates them.
 * The next React update then throws:
 * NotFoundError: Failed to execute 'removeChild' on 'Node'.
 * Skipping a node that is no longer in the expected parent keeps the interview usable.
 */
let warned = false

function warnOnce() {
  if (warned) return
  warned = true
  console.warn(
    'Skipped a DOM update on a node the browser moved. This usually means the page was translated or an extension edited it.'
  )
}

export function installDomCrashGuard() {
  if (typeof Node !== 'function') return
  const prototype = Node.prototype as Node & { __selektiaDomGuard?: boolean }
  if (prototype.__selektiaDomGuard) return

  const originalRemoveChild = prototype.removeChild
  prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      warnOnce()
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = prototype.insertBefore
  prototype.insertBefore = function insertBefore<T extends Node>(
    this: Node,
    node: T,
    child: Node | null
  ): T {
    if (child && child.parentNode !== this) {
      warnOnce()
      return node
    }
    return originalInsertBefore.call(this, node, child) as T
  }

  prototype.__selektiaDomGuard = true
}

installDomCrashGuard()
